import { GetStaticProps } from 'next';

import {
  BlogClosingCta,
  BlogFeed,
  FeaturedPostHero,
} from '../../components/blog/BlogListing';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import {
  BLOG_DESCRIPTION,
  BLOG_TITLE,
  getFeaturedPost,
  postsNewestFirst,
} from '../../content/blog/posts';
import { DefaultLocale } from '../../providers/tolgee';
import { getCanonicalUrl } from '../../utils/client';

const BlogIndexPage = () => {
  const featured = getFeaturedPost();
  const rest = postsNewestFirst().filter(post => post.slug !== featured.slug);
  const canonical = getCanonicalUrl('/c/blogs');

  return (
    <LandingPageLayout
      title={BLOG_TITLE}
      subTitle={BLOG_DESCRIPTION}
      disableHeadline
      canonicalPath="/c/blogs"
      imageUrl={getCanonicalUrl(featured.cover)}
      structuredData={[
        {
          '@context': 'https://schema.org',
          '@type': 'Blog',
          name: BLOG_TITLE,
          description: BLOG_DESCRIPTION,
          url: canonical,
          blogPost: postsNewestFirst().map(post => ({
            '@type': 'BlogPosting',
            headline: post.title,
            datePublished: post.publishedAt,
            url: getCanonicalUrl(`/c/blog-posts/${post.slug}`),
          })),
        },
        {
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          itemListElement: postsNewestFirst().map((post, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: post.title,
            url: getCanonicalUrl(`/c/blog-posts/${post.slug}`),
          })),
        },
      ]}
    >
      <FeaturedPostHero post={featured} />
      <BlogFeed active="all" posts={rest} />
      <BlogClosingCta />
    </LandingPageLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      _tolgeeSSR: {
        language: DefaultLocale,
      },
    },
  };
};

export default BlogIndexPage;
